import { render } from "./apply2.vue?vue&type=template&id=088e2389&scoped=true"
import script from "./apply2.vue?vue&type=script&lang=js"
export * from "./apply2.vue?vue&type=script&lang=js"

import "./apply2.vue?vue&type=style&index=0&id=088e2389&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088e2389"]])

export default __exports__